import { render, staticRenderFns } from "./BeyondEconomicalRepair.vue?vue&type=template&id=29460f70&"
import script from "./BeyondEconomicalRepair.vue?vue&type=script&lang=js&"
export * from "./BeyondEconomicalRepair.vue?vue&type=script&lang=js&"
import style0 from "./BeyondEconomicalRepair.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports